import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_HEIGHT_SHORT,
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_BLUE_BORDER,
} from 'client/components/SrButton/SrButton';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';

const BulkIgnoreConfirmModal = ({
  count,
  isSubmitting,
  errorMessage,
  onConfirm,
  onClose,
}) => {
  const title = count === 1 ? 'Ignore 1 address?' : `Ignore ${count} addresses?`;
  const body =
    count === 1
      ? 'This address will be removed from the resolution dashboard and will not be processed.'
      : 'These addresses will be removed from the resolution dashboard and will not be processed.';

  return (
    <SrModalV2
      onClose={isSubmitting ? undefined : onClose}
      showCloseButton={false}
      contentMaxWidth="480px"
      contentPadding="0"
      centerContent
    >
      <SrBox
        backgroundColor="white"
        padding="24px"
        borderRadius="12px"
      >
        <SrText font="greycliff" weight="700" size="20" lineHeight="26px">
          {title}
        </SrText>
        <SrBox mt="12px">
          <SrText font="greycliff" weight="500" size="14" lineHeight="20px">
            {body}
          </SrText>
        </SrBox>
        {errorMessage && (
          <SrBox mt="12px">
            <SrText font="greycliff" weight="600" size="13" color="red500">
              {errorMessage}
            </SrText>
          </SrBox>
        )}
        <SrBox mt="20px">
          <SrFlex justify="end" columnGap="10px">
            <SrButton
              heightType={SR_BUTTON_HEIGHT_SHORT}
              theme={SR_BUTTON_THEME_ADOBE_BLUE_BORDER}
              onClick={onClose}
              disabled={isSubmitting}
              minWidth="100px"
            >
              Cancel
            </SrButton>
            <SrButton
              heightType={SR_BUTTON_HEIGHT_SHORT}
              theme={SR_BUTTON_THEME_ADOBE_YELLOW}
              onClick={onConfirm}
              disabled={isSubmitting}
              minWidth="100px"
            >
              {isSubmitting ? 'Ignoring…' : 'Ignore'}
            </SrButton>
          </SrFlex>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

BulkIgnoreConfirmModal.propTypes = {
  count: PropTypes.number.isRequired,
  isSubmitting: PropTypes.bool,
  errorMessage: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

BulkIgnoreConfirmModal.defaultProps = {
  isSubmitting: false,
  errorMessage: null,
};

BulkIgnoreConfirmModal.displayName = 'BulkIgnoreConfirmModal';

export default BulkIgnoreConfirmModal;
